const reqFiles = require.context('../style', true, /(.less|.css)$/)
const requireAll = requireContext => requireContext.keys().forEach(requireContext)
requireAll(reqFiles)
